import { useEffect } from "react"
import { DeviceType, useDeviceType } from "./useDeviceType"

export function useViewportHeight() {
  const device = useDeviceType()

  useEffect(() => {
    if (device === DeviceType.Desktop) return

    const setVh = () => {
      const vv = window.visualViewport
      const usableHeight = vv ? vv.height : window.innerHeight
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${usableHeight}px`
      )
    }

    setVh()

    const handleResize = () => {
      setVh()

      if (Math.abs(window.scrollY) > 0) {
        window.scrollTo(0, 0)
      }
    }

    window.visualViewport?.addEventListener("resize", handleResize)
    window.addEventListener("resize", handleResize)

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize)
      window.removeEventListener("resize", handleResize)
    }
  }, [])
}
